<template>
  <div class="flex bookFooter">
    <router-link to="/index" class="indexBtn">
      <span class="iconfont icon-shouye"></span>
      <p class="fs_12">首页</p>
    </router-link>
    <!-- <router-link :to="'/'+jump" class="bookFooter_item bookBtn">立即预约</router-link> -->
     <a  :class="['bookFooter_item','bookBtn',none_btn==1?'none_bg':'']" @click="jump()">立即预约</a>
  </div>
</template>

<script>
    export default {
        name: "bookFooter",
        // props:['tech_id'],
        data(){
          return{
            store_id:0,
            tech_id:0,
            service_id:0,  
            none_btn:0,          
            // jump:'bookOrder'
          }          
          
        },
        created(){
          this.store_id = this.$route.query.store_id?this.$route.query.store_id:0;
          this.tech_id = this.$route.query.tech_id?this.$route.query.tech_id:0;
          this.service_id = this.$route.query.service_id?this.$route.query.service_id:0;
          // if(this.tech_id){
          //    this.jump = 'itemList'
          // }
          this.init();
        },
        methods:{
          init(){
             if(this.store_id){
                this.axios({
                    url: this.api.book.get_store,
                    data:{
                      'store_id':this.store_id
                    }
                }).then((res) => {
                    if (res.error === 0) {
                       if(res.store.status!=1){
                          this.none_btn = 1
                       }
                    }

                })
             }
             if(this.tech_id){
                 this.axios({
                    url: this.api.book.get_tech,
                    data:{
                      'tech_id':this.tech_id
                    }
                }).then((res) => {
                    if (res.error === 0) {
                      if(res.tech.status!=1){
                          this.none_btn = 1
                       }
                    }

                })
             }
          },
          jump(){
            if(this.none_btn==1){
                return;
            }
             var jump_data = {};
               if(this.store_id!=0){
                     jump_data['store_id'] = this.store_id;
               }
               if(this.tech_id!=0){
                     jump_data['tech_id'] = this.tech_id;
               }
               if(this.service_id!=0){
                     jump_data['service_id'] = this.service_id;
               }
            if(this.tech_id!=0&&this.service_id==0){
              
              this.$router.push({path:'itemlist',query:jump_data});
            }else{
               this.axios({
                    url: this.api.order.place_order,
                    data:{
                      service_id:this.service_id,
                      store_id:this.store_id,
                      tech_id:this.tech_id,
                      member_total:1,
                      service_time:''
                    }
                }).then((res) => {
                    if (res.error === 0) {
                       this.$router.push({path:'bookOrder',query:jump_data});
                    }

                })
             
            }
           
          }
        }
        
    }
</script>

<style scoped>
  .bookFooter{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2.5rem;
    background: #fff;
    font-size: .6rem;
  }
  .bookFooter a{
    height: 100%;
    text-align: center;
  }
  .indexBtn{
    width: 28%;
    color: #999;
    padding: .3rem 0;
  }
  .indexBtn .iconfont{
    font-size: 1rem;
  }
  .bookBtn{
    width: 72%;
    font-size: .9rem;
    color: #fff;
    background: #45B9BC;
    line-height: 2.5rem;
  }
  .none_bg{
    background: #d2d2d2;
  }

</style>



// WEBPACK FOOTER //
// src/components/bookFooter.vue